exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.actions[data-v-5656e022] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.center[data-v-5656e022] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 15rem;\n  text-align: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.tableContainer[data-v-5656e022] {\n  height: 90vh;\n}\n", ""]);

// exports
